import ProductsStatusTable from "./ProductsStatusTable";

export default ProductsStatusTable;
